module.exports = __webpack_public_path__ + "static/media/hammer-and-wrench_1f6e0.af2a0ecd.png";